module.exports = __webpack_public_path__ + "static/media/icn_arrow_up.4fe0a004.svg";